import { createContext } from 'react';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
export default createContext();
